import React, { Component } from 'react';
import '../App.css';

class Ebay extends Component {
  render() {
    if (Object.keys(this.props.content).length !== 0) {
      return (
        <div className="store_box">
          <div className="store_header">
            <span>Ebay:</span>
          </div>
          <div className="ebay_results">
            <p>{this.props.content.join(', ')}</p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="store_box">
          <div className="store_header">
            <b>Ebay:</b>
          </div>
          <div className="ebay_results">
            <p>Loading...</p>
          </div>
        </div>
      );
    }
  }
}

export default Ebay;



// WEBPACK FOOTER //
// ./client/src/Engines/Ebay.js